import { Badge } from '../ui';
import type { JobStatus } from '../../types';

const getVideoProgressCopy = (status: JobStatus | null) => {
  if (!status) return '';

  const progress = Math.max(0, Math.min(100, status.progress ?? 0));

  if (status.status === 'queued') return 'Queued. A worker is picking it up now.';
  if (progress < 20) return 'Setting up the render and preparing the first frames.';
  if (progress < 45) return 'Building motion and stitching the clip together.';
  if (progress < 75) return 'Rendering the heavy part. This is where it usually takes a while.';
  if (progress < 95) return 'Polishing the final output and encoding the file.';
  return 'Almost there. Final checks are running.';
};

type VideoProgressBannerProps = {
  videoJobStatus: JobStatus | null;
};

export function VideoProgressBanner({ videoJobStatus }: VideoProgressBannerProps) {
  return videoJobStatus && videoJobStatus.status !== 'completed' ? (
    <div className="cp-video-progress" role="status" aria-live="polite">
      <div className="cp-video-progress__topline">
        <div>
          <div className="cp-video-progress__eyebrow">Video render in progress</div>
          <div className="cp-video-progress__title">
            {Math.max(0, Math.min(100, videoJobStatus.progress ?? 0))}% complete
          </div>
        </div>
        <Badge variant="scheduled" dot>
          {videoJobStatus.status === 'queued' ? 'Queued' : 'Rendering'}
        </Badge>
      </div>
      <div className="cp-video-progress__track" aria-hidden="true">
        <div
          className="cp-video-progress__fill"
          style={{ width: `${Math.max(0, Math.min(100, videoJobStatus.progress ?? 0))}%` }}
        />
      </div>
      <div className="cp-video-progress__meta">{getVideoProgressCopy(videoJobStatus)}</div>
    </div>
  ) : null;
}
